// qs-brushes-base.ts
import type { KonvaLine } from '@/types/qs-type-konva'
import Konva from 'konva'
import type { BrushConfig, BrushContext, BrushDrawingResult, BrushProperties, BrushRecreationContext } from '../qs-brushes-types'

type KonvaLineConfig = BrushProperties & {
  readonly stroke: string
  readonly opacity: number
  readonly draggable: boolean
}

export abstract class BaseBrush {
  abstract readonly config: BrushConfig

  abstract getProperties(size: number): BrushProperties

  abstract createBrushLine(context: BrushContext): KonvaLine

  abstract continueDrawing(existingLine: KonvaLine, context: BrushContext): void

  abstract finishDrawing(existingLine: KonvaLine, context: BrushContext): Promise<BrushDrawingResult>

  abstract recreateFromData(context: BrushRecreationContext): Promise<void>

  validateSize(size: number): boolean {
    return size >= this.config.minSize && size <= this.config.maxSize
  }

  getValidSize(size: number): number {
    if (size < this.config.minSize) return this.config.minSize
    if (size > this.config.maxSize) return this.config.maxSize
    return size
  }

  protected createBaseLineProperties(context: BrushContext): KonvaLineConfig {
    const properties = this.getProperties(context.size)
    return {
      stroke: context.color,
      opacity: context.opacity,
      draggable: false,
      ...properties
    }
  }

  protected createOriginalPath(points: number[], context: BrushContext, pathId: string): KonvaLine {
    const strokeWidth = Math.max(context.size * 0.3, 2)
    return new Konva.Line({
      id: `original-path-${pathId.replace('path-', '')}`,
      points: points,
      stroke: '#ef4444',
      strokeWidth: strokeWidth,
      lineCap: 'round',
      lineJoin: 'round',
      opacity: 0.6,
      visible: false,
      draggable: false,
      isOriginalPath: true,
      originalStrokeWidth: strokeWidth
    })
  }
}